import { Injectable } from '@angular/core';
import { timer } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SessionDialogComponent } from './session-dialog/session-dialog.component';

@Injectable()
export class TimedDialogService {
  public watch: any;
  public bsModalRef: BsModalRef;
  private subscription: any;
  private delay: number = 715000;
  constructor(private modalService: BsModalService) {
     this.startTimer();
  }
  public setDelay(delay: number) {
    this.delay = delay;
  }
  public showDialogAfterDelay() {
    if (!this.subscription) {
      this.subscription = this.watch.subscribe((val) =>  {
        this.bsModalRef = this.modalService.show(SessionDialogComponent,
          { animated: true, keyboard: false, backdrop: false, ignoreBackdropClick: true }
        );
      });
    } else {
      this.subscription.unsubscribe();
      this.subscription = this.watch.subscribe((val) => {
        this.bsModalRef = this.modalService.show(SessionDialogComponent,
          { animated: true, keyboard: false, backdrop: false, ignoreBackdropClick: true }
        );
      });
    }
  }
  public stopTimer() {
    this.subscription.unsubscribe();
  }
  private startTimer() {
    this.watch = timer(this.delay);
  }
}
